import { proxy } from 'valtio'
import { devtools } from 'valtio/utils'
import { type ApiCallType } from '../types/ApiCallType'

export interface MerchantType {
  merchantName: string
  ppMerchantId: string
}

export interface GlobalMerchantsProxyType {
  apiCall: ApiCallType
  selectedMerchant: MerchantType | null
  merchants: MerchantType[]
}

export const globalMerchantsProxy: GlobalMerchantsProxyType = proxy({
  apiCall: {
    error: null,
    loading: false
  },
  merchants: [],
  selectedMerchant: null
})

devtools(globalMerchantsProxy, { name: 'globalMerchants' })
